/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SavedPickup
 */
export interface SavedPickup {
  /**
   *
   * @type {string}
   * @memberof SavedPickup
   */
  businessName?: string | null;
  /**
   *
   * @type {string}
   * @memberof SavedPickup
   */
  addressLine?: string | null;
  /**
   *
   * @type {string}
   * @memberof SavedPickup
   */
  addressLine2?: string | null;
  /**
   *
   * @type {string}
   * @memberof SavedPickup
   */
  city?: string | null;
  /**
   *
   * @type {string}
   * @memberof SavedPickup
   */
  stateOrProvinceCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof SavedPickup
   */
  postalCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof SavedPickup
   */
  countryCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof SavedPickup
   */
  contactName?: string | null;
  /**
   *
   * @type {string}
   * @memberof SavedPickup
   */
  contactPhone?: string | null;
  /**
   *
   * @type {string}
   * @memberof SavedPickup
   */
  contactEmail?: string | null;
  /**
   *
   * @type {string}
   * @memberof SavedPickup
   */
  openFromLocalTime?: string | null;
  /**
   *
   * @type {string}
   * @memberof SavedPickup
   */
  openToLocalTime?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof SavedPickup
   */
  hasDock?: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof SavedPickup
   */
  hasForklift?: boolean | null;
}

/**
 * Check if a given object implements the SavedPickup interface.
 */
export function instanceOfSavedPickup(value: object): value is SavedPickup {
  return true;
}

export function SavedPickupFromJSON(json: any): SavedPickup {
  return SavedPickupFromJSONTyped(json, false);
}

export function SavedPickupFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SavedPickup {
  if (json == null) {
    return json;
  }
  return {
    businessName:
      json["businessName"] == null ? undefined : json["businessName"],
    addressLine: json["addressLine"] == null ? undefined : json["addressLine"],
    addressLine2:
      json["addressLine2"] == null ? undefined : json["addressLine2"],
    city: json["city"] == null ? undefined : json["city"],
    stateOrProvinceCode:
      json["stateOrProvinceCode"] == null
        ? undefined
        : json["stateOrProvinceCode"],
    postalCode: json["postalCode"] == null ? undefined : json["postalCode"],
    countryCode: json["countryCode"] == null ? undefined : json["countryCode"],
    contactName: json["contactName"] == null ? undefined : json["contactName"],
    contactPhone:
      json["contactPhone"] == null ? undefined : json["contactPhone"],
    contactEmail:
      json["contactEmail"] == null ? undefined : json["contactEmail"],
    openFromLocalTime:
      json["openFromLocalTime"] == null ? undefined : json["openFromLocalTime"],
    openToLocalTime:
      json["openToLocalTime"] == null ? undefined : json["openToLocalTime"],
    hasDock: json["hasDock"] == null ? undefined : json["hasDock"],
    hasForklift: json["hasForklift"] == null ? undefined : json["hasForklift"],
  };
}

export function SavedPickupToJSON(json: any): SavedPickup {
  return SavedPickupToJSONTyped(json, false);
}

export function SavedPickupToJSONTyped(
  value?: SavedPickup | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    businessName: value["businessName"],
    addressLine: value["addressLine"],
    addressLine2: value["addressLine2"],
    city: value["city"],
    stateOrProvinceCode: value["stateOrProvinceCode"],
    postalCode: value["postalCode"],
    countryCode: value["countryCode"],
    contactName: value["contactName"],
    contactPhone: value["contactPhone"],
    contactEmail: value["contactEmail"],
    openFromLocalTime: value["openFromLocalTime"],
    openToLocalTime: value["openToLocalTime"],
    hasDock: value["hasDock"],
    hasForklift: value["hasForklift"],
  };
}
